import React from 'react';
import './Hero.css';
import instagramImg from '../../assets/instagram.png';

export default function Hero() {
  return (
      <div className="hero">
        <h1>Snacks, Written in the Stars.</h1>
        <p>Astrology meets snacking. A modern way to discover your cosmic cravings.</p>
        <a href="https://www.instagram.com/snackstrology_com">
          <img alt="Instagram Icon" src={instagramImg}/> Instagram
        </a>
      </div>
  );
}